import { TableBody, TableCell, TableRow } from "@mui/material";
import DynamicTable from "../../../components/tables/dynamicTable";
import { DateProgressBar } from "../../../components/hospitalManagement/dateProgressBar";
import moment, { Moment } from "moment";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import routesName from "../../../constants/routesName";
import { useAppDispatch } from "../../../redux/store";
import { getHospitalById, getHospitalByStatus } from "../../../redux/addHospital/hospitalManagementReducer";
import successToast from "../../../utils/successToast";
import errorToast from "../../../utils/errorToast";
import { LoadingSpinner } from "../../../components/ui/loadinSpinner";
import { removeUnderScore } from "../../../helper";
import useDisplayToggle from "../../../utils/useDisplayToggle";
import useAxios from "../../../hooks/useAxios";
import { hospitalApi } from "../../../jsonData/apiPathData/hospital";
import DeleteIcon from "../../../assests/icons/deleteIcon.png";
import ConfirmationModal from "../../../components/modals/confirmationModal";
import { formatIndianRupee } from "../../../utils/formatIndianRupee";
import { ActionTooltip } from "../../../utils/toolTip";
import { AsyncAccessTokenDecoder } from "../../../utils/accessTokenDecoder";
import axios from "axios";
import { Grid } from "@mui/material";
import DataRangeSelector from "../../../components/dataRangeSelector";
// import Departments from "../../mis/patientDetails/departments";
// import Diagnosis from "../../mis/patientDetails/diagnosis";
import { CustomHeight } from "../../../components/themeProvider";
import InPatientOccupied from "./Patient Type/InPatientOccupied";
import OccpancyCharts from "./occupancyCharts/OccpancyCharts";
import EquipmentDetailsChart from "./occupancyCharts/EquipmentDetailsChart";
// import api from "../../../datasource/api";
import MADepartment from "../../mis/patientDetails/MADepartment";
import MADiagnosis from "../../mis/patientDetails/MADiagnosis";
import { useQuery } from "@tanstack/react-query";
import api from "../../../datasource/api";
import dayjs from "dayjs";

const HospitalDashBoardTab = ({ hospitalDetailsRes }: any) => {
  const styles = {
    // borderLeft: "1px solid #F2F4F7",
    borderRight: "1px solid #F2F4F7",
    borderBottom: "1px solid #F2F4F7",
    background: "white",
    minWidth: "150px",
    maxWidth: "150px",
    paddingLeft: "16px",
    paddingRight: "16px",
    color: "#667085",
    fontWeight: 500,
    fontFamily: "Inter, sans-serif",
    height: "70px",
  };
  const currentDate = new Date();



  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const hospitalId = hospitalDetailsRes?.data?.data?.hospitalId;
  const [productId, setProductId] = useState<number>();
  const [action, setAction] = useState("");
  const [isShowModal, setIsShowModal] = useState(false);
  const [clinicalAssitantStatus, setClinicalAssitantStatus] = useState(false);
  const [managmentAssitantStatus, setManagmentAssitantStatus] = useState(false);
  const decodeToken = AsyncAccessTokenDecoder();
  // const currentDate = new Date();
  // const currentDate = new Date();
  const currentMonth = moment(currentDate).month(); // 0-indexed: 0 = Jan, 3 = Apr

  let financialYearStart;

  // If current month is Jan, Feb, or Mar, the financial year started in the previous calendar year
  if (currentMonth < 3) {
    financialYearStart = moment(currentDate).subtract(1, 'year').month(3).startOf('month');
  } else {
    // Otherwise, it started in April of the current calendar year
    financialYearStart = moment(currentDate).month(3).startOf('month');
  }

  // The financial year ends on March 31st of the following calendar year from the start
  const currentYearStart = financialYearStart;
  const currentYearEnd = moment(financialYearStart).add(11, 'months').endOf('month');
  const [fromDate, setFromDate] = useState<Moment | null>(currentYearStart);
  const [toDate, setToDate] = useState<Moment | null>(currentYearEnd);
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const [district, setDistrict] = useState("");
  const [taluk, setTaluk] = useState("");
  const [hobli, setHobli] = useState("");
  const [serviceType, setServiceType] = useState<any>("");
  const [filterApplyToggle, setFilterApplyToggle] = useState(false);
  const productAndPlanInfo =
    hospitalDetailsRes?.data?.data?.productandPlanInfos;
  const params = useParams();
  const [moreOption, setMoreOption] = useState<null | number | boolean>(null);
  const [isMoreOption, setisMoreOption] = useState<any>(false);

  const onClickRef = useRef(null);
  const insideClickRef = useRef(null);
  useDisplayToggle({
    onClickRef,
    insideClickRef,
    setDisplay: setisMoreOption,
  });

  useEffect(() => {
    if (isMoreOption === false) {
      setMoreOption(null);
    }
  }, [isMoreOption]);

  const toogle = (index: number) => {
    if (moreOption === index) {
      setisMoreOption(false);
      setMoreOption(null);
    } else {
      setMoreOption(index);
      setisMoreOption(true);
    }
  };

  useEffect(() => {
    // 1. Create/join the sync channel
    const channel = new BroadcastChannel('hospital_update_channel');

    // 2. Listen for messages from the spawned window
    channel.onmessage = (event) => {
      if (event.data === 'HOSPITAL_UPDATED') {
        // 3. Trigger your dispatches reactively!
        dispatch(
          getHospitalByStatus({
            status: (sessionStorage.getItem("hospitalStatus") as string) ?? "allStatus",
            orderBy: '',
            order: '',
            page: 0,
            rowsPerPage: 10,
            searchQuery: "",
            searchKeywords: '',
          })
        );

        if (params?.id) {
          dispatch(getHospitalById(params.id as string));
        }
      }
    };

    // 4. Clean up the channel connection when component unmounts
    return () => {
      channel.close();
    };
  }, [dispatch, params?.id]);

  const editHospitalFn = () => {
    window.open(`${routesName.hospitalManagementPage}/edit-product-plan/${hospitalId}?closeonsave=true`, 'Edit Product Info', 'width=800,height=600');
    // navigate(
    //   `${routesName.hospitalManagementPage}/edit-product-plan/${hospitalId}`
    // );
  };

  // checking for cilincial assistant is active or not
  useEffect(() => {
    const clinicalAssitStatus =
      productAndPlanInfo?.find(
        (item: any) => item?.productInfo?.productId === 1001
      )?.planInfo?.isActive === 1;
    setClinicalAssitantStatus(clinicalAssitStatus);
    const managementAssitStatus =
      productAndPlanInfo?.find(
        (item: any) => item?.productInfo?.productId === 1000
      )?.planInfo?.isActive === 1;
    setManagmentAssitantStatus(managementAssitStatus);
  }, [productAndPlanInfo]);

  const hospitalActiveDeactivateFn = (productId: number, action: string) => {
    if (productId === 1000 && clinicalAssitantStatus) {
      errorToast(
        "You can't deactivate Management Assistant while Clinical Assistant is still active"
      );
    } else if (productId === 1001 && !managmentAssitantStatus) {
      errorToast(
        "You can't activate Clinical Assistant while Management Assistant is deactive"
      );
    } else {
      setProductId(productId);
      setAction(action);
      setIsShowModal(true);
    }
  };

  // console.log(hospitalId, "hospitalIdhospitalId")
  // activate deactivate product axios call
  const {
    data: activateOrDeactivateSuccess,
    error: activateOrDeactivateError,
    loading: activateOrDeactivateLoading,
    postFn: activateOrDeactivateFn,
    toggle,
  } = useAxios({
    method: "post",
    path: `${hospitalApi.activateOrDeactivate
      }hospitalid=${hospitalId}&productid=${productId}&isactive=${action === "Deactivate" ? 0 : 1
      }`,
  });

  const getALlLocation = async () => {
    const singleLocations = await api.get('/CMMIS/ccmis/hospitalbedsummarysingle', { params: { hospitalid: hospitalId, fromdate: dayjs().startOf("day").toISOString(), todate: dayjs().endOf("day").toISOString() } });
    const multipleLocations = await api.get('/CMMIS/ccmis/hospitalbedsummarymultiple', { params: { hospitalid: hospitalId, fromdate: dayjs().startOf("day").toISOString(), todate: dayjs().endOf("day").toISOString() } });

    return [...singleLocations.data?.map((v: any) => ({ ...v, isSingle: true })), ...multipleLocations.data]

  }

  const { data } = useQuery({ queryKey: [hospitalId], queryFn: () => getALlLocation() })

  useEffect(() => {
    const handleDeactivation = async () => {
      if (!activateOrDeactivateSuccess?.success) return;

      successToast(activateOrDeactivateSuccess?.message);

      // Only proceed when product is Deactivated
      if (action === "Deactivate") {
        try {
          const loginUrl = process.env.REACT_APP_MA_LOGIN_NEW_URL || "";
          const deactivateUrl = process.env.REACT_APP_MA_DEACTIVATE_HOSPITAL_URL || "";




          // 4. Call the MA deactivate API
          if (hospitalId) {
            const maResponse = await axios.get(deactivateUrl, {
              headers: {
                Authorization: `Bearer ${sessionStorage.getItem("newlogin")}`,
                "Content-Type": "application/json",
              },
              params: { hospitalId },
            });
            if (maResponse) {
              // 1. Get stored MA credentials
              const userString = sessionStorage.getItem("maLoginCredentials");
              const user = userString ? JSON.parse(userString) : null;

              const loginBody = {
                email: user?.email,
                password: user?.password,
              };

              // 2. Login to MA and get new token
              const loginResponse = await axios.post(
                loginUrl,
                loginBody,
                {
                  headers: {
                    "Content-Type": "application/json",
                    accept: "*/*",
                  },
                }
              );

              const accessToken = loginResponse?.data?.access_token;

              // 3. Save new token
              sessionStorage.setItem("newlogin", accessToken);
              window.location.reload();
            }
            // console.log("MA API Response:", maResponse.data);
          }
        } catch (err: any) {
          console.error("MA API Error:", err);
          errorToast("MA Assistant API failed");
        }
      }

      // 5. Refresh hospital details
      dispatch(getHospitalById(hospitalId));
    };

    handleDeactivation();
  }, [
    activateOrDeactivateSuccess,
    activateOrDeactivateError,
    toggle,
    productId,
    action,
    hospitalId,
    dispatch,
  ]);

  const TblBodyProductPlan = () => {

    return (
      <TableBody>
        {productAndPlanInfo?.map((item: any, index: any) => {
          const validityEnd = item?.planInfo?.validityEnd;
          // console.log(validityEnd, 'validityEnd');
          const isValidityPastOneMonthBeforeExpiry = () => {
            if (!validityEnd) return false;

            const today = dayjs().startOf("day");
            const end = dayjs(validityEnd).startOf("day");
            const diffInDays = end.diff(today, "day");
            // return true only if expiry is within the next 0-30 days
            console.log(diffInDays, 'diffInDays');
            return diffInDays >= 0 && diffInDays <= 31;
          };

          // console.log(isValidityPastOneMonthBeforeExpiry(), 'isValidityPastOneMonthBeforeExpiry');
          return (
            <TableRow key={index}>
              <TableCell
                style={{
                  ...styles,
                  minWidth: "80px",
                  maxWidth: "80px",
                  textAlign: "center",
                  left: "0px",
                }}
              >
                <ActionTooltip
                  content={
                    <div
                      className="bg-white absolute left-[-12px] bottom-[-40px] mt-1 ms-12 border z-30 flex flex-col shadow-lg rounded-lg whitespace-nowrap"
                      ref={insideClickRef}
                    >
                      {isValidityPastOneMonthBeforeExpiry() &&
                        decodeToken?.Roles !== "Admin" ? (
                        <button
                          type="button"
                          className="p-3 px-5 text-start text-secondary bg-white hover:text-primary hover:bg-blue-200 font-medium hover:font-semibold rounded-t-lg rounded-b-lg"
                          onClick={() => editHospitalFn()}
                        >
                          Renew
                        </button>
                      ) : (
                        <>
                          {item?.planInfo?.isActive === 1 && (
                            <button
                              type="button"
                              className="p-3 px-5 text-start text-secondary bg-white hover:text-primary hover:bg-blue-200 font-medium hover:font-semibold  rounded-t-lg"
                              onClick={() => editHospitalFn()}
                            >
                              Edit
                            </button>
                          )}

                          {item?.planInfo?.isActive === 1 && decodeToken?.Roles !== "Admin" && (
                            <button
                              type="button"
                              className={`p-3 px-5 text-start text-secondary bg-white hover:text-primary hover:bg-blue-200 font-medium hover:font-semibold rounded-b-lg ${validityEnd > currentDate && ""
                                } `}
                              onClick={() =>
                                hospitalActiveDeactivateFn(
                                  item?.productInfo?.productId,
                                  "Deactivate"
                                )
                              }
                            >
                              {activateOrDeactivateLoading ? (
                                <LoadingSpinner width="w-4" height="h-4" />
                              ) : (
                                "Deactivate"
                              )}
                            </button>
                          )}
                          {item?.planInfo?.isActive === 0 && (
                            <>
                              <button
                                type="button"
                                className={`p-3 px-5 text-start text-secondary bg-white hover:text-primary hover:bg-blue-200 font-medium hover:font-semibold rounded-t-lg ${validityEnd > currentDate && ""
                                  } `}
                                onClick={() => editHospitalFn()}
                              >
                                Edit
                              </button>{" "}
                              {decodeToken?.Roles !== "Admin" && <button
                                type="button"
                                className={`p-3 px-5 text-start text-secondary bg-white hover:text-primary hover:bg-blue-200 font-medium hover:font-semibold rounded-b-lg ${validityEnd > currentDate && ""
                                  } `}
                                onClick={() =>
                                  hospitalActiveDeactivateFn(
                                    item?.productInfo?.productId,
                                    "Activate"
                                  )
                                }
                              >
                                Reactivate
                              </button>}
                            </>
                          )}
                        </>
                      )}
                    </div>
                  }
                >
                  <button
                    className="text-blue-300 w-[24px] h-[24px]"
                    type="button"
                    onClick={() => toogle(index)}
                    ref={onClickRef}
                  >
                    <MoreVertIcon />
                  </button>
                </ActionTooltip>
              </TableCell>
              <TableCell style={{ ...styles, minWidth: "250px" }}>
                <span> {item?.productInfo?.name == "Management Assistant" ? "Buisness Management" : item?.productInfo?.name}</span>
              </TableCell>
              <TableCell style={{ ...styles, minWidth: "200px" }}>
                {item?.addOnServices?.length <= 0 && "-"}
                {item?.addOnServices?.map((ser: any, index: any) => {
                  return (
                    <span key={index + ser?.serviceName}>
                      {ser?.serviceName}
                      {index !== item.addOnServices.length - 1 && ", "}
                    </span>
                  );
                })}
              </TableCell>
              <TableCell style={{ ...styles, minWidth: "250px" }}>
                <>
                  <span className="font-bold mb-10">
                    {"Paid"}
                  </span>

                </>

              </TableCell>
              <TableCell style={{ ...styles, minWidth: "250px" }}>
                <>
                  <span className="font-bold mb-10">
                    {item?.planInfo?.isPilot
                      ? removeUnderScore(item?.planInfo?.isPilot ? "Pilot" : "Expired")
                      : "-"}
                  </span>

                </>
                <>
                  {item?.planInfo?.isPilot && <>
                    <DateProgressBar
                      validityStart={
                        item?.planInfo?.pilotFromDate ?? 0
                      }
                      validityEnd={
                        item?.planInfo?.pilotToDate ?? 0
                      }
                    />
                    <span className="border-l border-gray-300 ps-2">
                      <span>Exp. Date:</span>
                      <span className="font-semibold text-primary">
                        {item?.planInfo
                          ?.pilotToDate
                          ? moment(
                            item?.planInfo
                              ?.pilotToDate
                          ).format("DD MMM YYYY")
                          : " -"}
                      </span>
                    </span>
                  </>}
                </>
              </TableCell>
              <TableCell style={styles}>
                {item?.planInfo?.planType
                  ? removeUnderScore(item?.planInfo?.planType)
                  : "-"}
              </TableCell>
              <TableCell style={styles}>
                {item?.planInfo?.subscriptionPackage
                  ? removeUnderScore(item?.planInfo?.subscriptionPackage == 1 ? "Gold" : item?.planInfo?.subscriptionPackage == 2 ? "Silver" : item?.planInfo?.subscriptionPackage == 3 ? "Basic" : "")
                  : "-"}
              </TableCell>
              <TableCell style={styles}>
                {item?.planInfo?.patientType === "all"
                  ? item?.planInfo?.planTotalAmount === 0
                    ? "Free"
                    : formatIndianRupee(item?.planInfo?.planTotalAmount)
                  : item?.planInfo?.patientType === "in_patient"
                    ? item?.planInfo?.inPatientAmount === 0
                      ? "Free"
                      : formatIndianRupee(item?.planInfo?.inPatientAmount)
                    : item?.planInfo?.patientType === "out_patient"
                      ? item?.planInfo?.outPatientAmount === 0
                        ? "Free"
                        : formatIndianRupee(item?.planInfo?.outPatientAmount)
                      : "Free"}
              </TableCell>

              <TableCell style={{ ...styles, minWidth: "320px" }}>
                <div className="flex gap-3 items-center whitespace-nowrap">
                  {/* {item?.planInfo?.planType !== "per_annum" ? (
                    "NA"
                  ) : ( */}
                  <>
                    <DateProgressBar
                      validityStart={item?.planInfo?.validityStart}
                      validityEnd={item?.planInfo?.validityEnd}
                    />
                    <span>
                      Exp. Date:
                      <span className="text-primary font-semibold">
                        {moment(item?.planInfo?.validityEnd).format(
                          "DD MMM YYYY"
                        )}
                      </span>
                    </span>
                  </>
                  {/* )} */}
                </div>
              </TableCell>
              <TableCell style={{ ...styles, minWidth: "320px" }}>
                <div className="flex gap-3 items-center whitespace-nowrap">

                  {item?.planInfo?.trialFromDate && item?.planInfo?.trialToDate ? <>
                    <DateProgressBar
                      validityStart={item?.planInfo?.trialFromDate}
                      validityEnd={item?.planInfo?.trialToDate}
                    />
                    <span>
                      Exp. Date:
                      <span className="text-primary font-semibold">
                        {moment(item?.planInfo?.trialToDate).format(
                          "DD MMM YYYY"
                        )}
                      </span>
                    </span>
                  </> : <>{"NA"}</>}
                </div>
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    );
  };


  // console.log(data);


  return (
    <>
      <ConfirmationModal
        isVisible={isShowModal}
        onClose={() => {
          setIsShowModal(false);
        }}
        onClick={() => {
          activateOrDeactivateFn();
        }}
        icon={DeleteIcon}
        title={`Are you sure you want to ${action} this plan?`}
        description=""
        actionText={action}
        isLoading={activateOrDeactivateLoading}
      />
      <div className="mt-4">
        <span className="text-20 text-primary font-semibold">
          Product and Plan
        </span>
        <div className="pt-3">
          <DynamicTable
            columnData={columnHeader}
            children={<TblBodyProductPlan />}
            pagination={false}
          />
        </div>
      </div>
      <Grid container spacing={4} mb={4} mt={1}>

        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            paddingTop: "25px",
          }}
        >
          <div>
            <span className="text-20 font-[600] text-primary">
              Patient Type
            </span>
          </div>

          {/* <DataRangeSelector
            fromDate={fromDate}
            setFromDate={setFromDate}
            toDate={toDate}
            setToDate={setToDate}
            py="py-[8px]"
            border="border-gray-300"
            borderRadius="rounded-lg"
            shadow
            position="right-0"
          /> */}
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={6}
          style={{ paddingTop: "25px" }}
          sx={(theme) => ({
            display: "flex",
            height: {
              xs: "350px",
              sm: "400px",
              md: "400px",
              lg: "400px",
              xl: "450px",
              ...CustomHeight(theme),
            },
          })}
        >
          <InPatientOccupied
            // fromDate={fromDate}
            // toDate={toDate}
            country={country}
            state={state}
            district={district}
            taluk={taluk}
            hobli={hobli}
            serviceType={serviceType}
            filterApplyToggle={filterApplyToggle}
            hospitalId={hospitalId}
            patientType={1}
            title="In-Patients (IP)"
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={6}
          style={{ paddingTop: "25px" }}
          sx={(theme) => ({
            display: "flex",
            height: {
              xs: "350px",
              sm: "400px",
              md: "400px",
              lg: "400px",
              xl: "450px",
              ...CustomHeight(theme),
            },
          })}
        >
          <InPatientOccupied
            // fromDate={fromDate}
            // toDate={toDate}
            title="Out-Patients (OP)"
            country={country}
            state={state}
            district={district}
            taluk={taluk}
            hobli={hobli}
            serviceType={serviceType}
            patientType={2}
            hospitalId={hospitalId}
            filterApplyToggle={filterApplyToggle}
          />
        </Grid>
      </Grid>
      <Grid container spacing={4} mb={4}>

        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            paddingTop: "25px",
          }}
        >
          <div>
            <span className="text-20 font-[600] text-primary">
              Occupancy Details
            </span>
          </div>


        </Grid>

        {data?.map((v: any) => {
          // console.log(v);
          return v?.isSingle ? <Grid
            key={v?.hospitallocationtypedescription}
            item
            xs={12}
            sm={12}
            md={12}
            lg={6}
            style={{ paddingTop: "25px" }}
            sx={(theme) => ({
              display: "flex",
              height: {
                xs: "350px",
                sm: "400px",
                md: "400px",
                lg: "400px",
                xl: "450px",
                ...CustomHeight(theme),
              },
            })}
          >
            <OccpancyCharts
              fromDate={fromDate?.toISOString()}
              toDate={toDate?.toISOString()}
              country={country}
              state={state}
              district={district}
              taluk={taluk}
              hobli={hobli}
              serviceType={serviceType}
              filterApplyToggle={filterApplyToggle}
              title={v?.hospitallocationtypedescription + " Beds"}
              locationData={v}
              bedType="ICU"
              hospitalid={hospitalId}
            />
          </Grid> : <Grid
            key={v?.hospitallocationtypedescription}
            item
            xs={12}
            sm={12}
            md={12}
            lg={6}
            style={{ paddingTop: "25px" }}
            sx={(theme) => ({
              display: "flex",
              height: {
                xs: "350px",
                sm: "400px",
                md: "400px",
                lg: "400px",
                xl: "450px",
                ...CustomHeight(theme),
              },
            })}
          >
            <OccpancyCharts
              fromDate={fromDate?.toISOString()}
              toDate={toDate?.toISOString()}
              country={country}
              state={state}
              district={district}
              taluk={taluk}
              hobli={hobli}
              serviceType={serviceType}
              filterApplyToggle={filterApplyToggle}
              title={v?.hospitallocationtypedescription + " Tables"}
              bedType="OT"
              locationData={v}
              hospitalid={hospitalId}
            />
          </Grid>
        })}



        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={6}
          style={{ paddingTop: "25px" }}
          sx={(theme) => ({
            display: "flex",
            height: {
              xs: "350px",
              sm: "400px",
              md: "400px",
              lg: "400px",
              xl: "450px",
              ...CustomHeight(theme),
            },
          })}
        >
          <EquipmentDetailsChart hospitalid={hospitalId} />
        </Grid>
      </Grid>


      <Grid container spacing={4} mb={4}>

        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            paddingTop: "25px",
          }}
        >
          <div>
            <span className="text-20 font-[600] text-primary">
              Patient Details
            </span>
          </div>

          <DataRangeSelector
            fromDate={fromDate}
            setFromDate={setFromDate}
            toDate={toDate}
            setToDate={setToDate}
            py="py-[8px]"
            border="border-gray-300"
            borderRadius="rounded-lg"
            shadow
            position="right-0"
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={6}
          style={{ paddingTop: "25px" }}
          sx={(theme) => ({
            display: "flex",
            height: {
              xs: "350px",
              sm: "400px",
              md: "400px",
              lg: "400px",
              xl: "450px",
              ...CustomHeight(theme),
            },
          })}
        >
          {/* <Departments
            fromDate={fromDate}
            toDate={toDate}
            country={country}
            state={state}
            district={district}
            taluk={taluk}
            hobli={hobli}
            serviceType={serviceType}
            filterApplyToggle={filterApplyToggle}
            hospitalId={hospitalId}
          /> */}
          <MADepartment
            fromDate={fromDate}
            toDate={toDate}
            country={country}
            state={state}
            district={district}
            taluk={taluk}
            hobli={hobli}
            serviceType={serviceType}
            filterApplyToggle={filterApplyToggle}
            hospitalId={hospitalId}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={6}
          style={{ paddingTop: "25px" }}
          sx={(theme) => ({
            display: "flex",
            height: {
              xs: "350px",
              sm: "400px",
              md: "400px",
              lg: "400px",
              xl: "450px",
              ...CustomHeight(theme),
            },
          })}
        >
          <MADiagnosis
            fromDate={fromDate}
            toDate={toDate}
            country={country}
            state={state}
            district={district}
            taluk={taluk}
            hobli={hobli}
            serviceType={serviceType}
            filterApplyToggle={filterApplyToggle}
            hospitalId={hospitalId}

          />
          {/* <Diagnosis
            fromDate={fromDate}
            toDate={toDate}
            country={country}
            state={state}
            district={district}
            taluk={taluk}
            hobli={hobli}
            serviceType={serviceType}
            filterApplyToggle={filterApplyToggle}
            hospitalId={hospitalId}

          /> */}
        </Grid>
      </Grid>
    </>
  );
};

export default HospitalDashBoardTab;

const columnHeader = [
  {
    label: "Action",
    value: "action",
    sort: false,
    search: false,
  },
  {
    label: "Products",
    value: "products",
    sort: false,
    search: false,
  },
  {
    label: "Add-on Services",
    value: "add_on_services",
    sort: false,
    search: false,
  },
  {
    label: "Service Type",
    value: "service_type",
    sort: false,
    search: false,
  },
  {
    label: "Pilot",
    value: "is_pilot",
    sort: false,
    search: false,
  },
  {
    label: "Plan Type",
    value: "plan_type",
    sort: false,
    search: false,
  },
  {
    label: "Subscription Type",
    value: "subscription_type",
    search: false,
    sort: false,
  },
  {
    label: "Price",
    value: "price",
    sort: false,
    search: false,
  },
  {
    label: "Plan Validity",
    value: "plan_validity",
    sort: false,
    search: false,
  },
  {
    label: "Trial Period(Gold)",
    value: "trial_period_gold",
    // removeSticky: true,
    search: false,
    sort: false,
  },
];
